<template>
  <div class="record-page">
    <h1 class="page-title">购买记录</h1>

    <div v-if="!accountAddress" class="hint-box">
      请先连接钱包后查看订单
    </div>

    <div v-else-if="records.length === 0 && !loading && loadedOnce" class="hint-box empty">
      暂无订单记录
    </div>

    <PurchaseRecordItem
      v-for="row in records"
      :key="row.id"
      :item="row"
      @exchange-success="reloadList"
    />

    <div
      v-if="accountAddress && records.length > 0 && !listFinished"
      class="load-more"
    >
      <button
        type="button"
        class="load-more-btn"
        :disabled="loading"
        @click="loadMore"
      >
        {{ loading ? "加载中…" : "加载更多" }}
      </button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import PurchaseRecordItem from "./record/components/PurchaseRecordItem.vue";
import { get_order_list } from "@/api";

export default {
  name: "RecordView",
  components: {
    PurchaseRecordItem,
  },
  data() {
    return {
      records: [],
      nextPage: 1,
      limit: 10,
      loading: false,
      listFinished: false,
      loadedOnce: false,
    };
  },
  computed: {
    accountAddress() {
      return this.$store.state.user.accountAddress;
    },
  },
  watch: {
    accountAddress(val) {
      if (val) {
        this.loadedOnce = false;
        this.reloadList();
      } else {
        this.records = [];
        this.loadedOnce = true;
      }
    },
  },
  mounted() {
    if (this.accountAddress) {
      this.reloadList();
    } else {
      this.loadedOnce = true;
    }
  },
  methods: {
    reloadList() {
      this.nextPage = 1;
      this.listFinished = false;
      this.records = [];
      return this.fetchPage(false);
    },

    loadMore() {
      if (!this.loading && !this.listFinished && this.records.length > 0) {
        this.fetchPage(true);
      }
    },

    async fetchPage(append) {
      if (!this.accountAddress || this.loading) return;
      if (append && this.listFinished) return;

      this.loading = true;
      Toast.loading({ duration: 0, forbidClick: true });

      try {
        const res = await get_order_list({
          pages: String(this.nextPage),
          limit: String(this.limit),
          wallet: this.accountAddress,
        });

        const list = Array.isArray(res.data[0]) ? res.data[0] : [];

        if (append) {
          this.records = [...this.records, ...list];
        } else {
          this.records = [...list];
        }

        if (list.length < this.limit) {
          this.listFinished = true;
        } else {
          this.nextPage += 1;
        }
      } finally {
        Toast.clear();
        this.loading = false;
        this.loadedOnce = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.record-page {
  min-height: 100%;
  box-sizing: border-box;
  padding: 0 32px 32px;
  padding-bottom: calc(32px + env(safe-area-inset-bottom, 0px));
  color: #333;
}

.page-title {
  margin: 0 0 32px;
  font-size: 36px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 0.02em;
}

.hint-box {
  padding: 32px 24px;
  margin-bottom: 24px;
  font-size: 28px;
  line-height: 1.45;
  color: #595959;
  background: #fafafa;
  border-radius: 12px;
  text-align: center;
}

.hint-box.empty {
  color: #8c8c8c;
}

.load-more {
  margin-top: 32px;
}

.load-more-btn {
  width: 100%;
  height: 80px;
  border: none;
  border-radius: 12px;
  font-size: 28px;
  background: #e5c486;
  color: #fff;
  cursor: pointer;
}

.load-more-btn:disabled {
  opacity: 0.65;
  cursor: default;
}
</style>
